import { SyntheticEvent } from "react";
import { observer } from "mobx-react-lite";
import SearchStore from "core/stores/search.store";

type CityResultsProps = {
  store: SearchStore;
  selectCityAsync: (el: HTMLElement, city: string) => Promise<void>;
}

const CityResults = observer<CityResultsProps>((props) => {
  const { store, selectCityAsync } = props;

  const _selectCityAsync = async (e: SyntheticEvent, city: string) => {
    const el = e.target as HTMLElement;
    await selectCityAsync(el, city);
  }

  if (!store.filteredCities) {
    return null;
  }

  return <ul className="cities">
    {store.filteredCities.map((x, ix) => <li key={`city-${ix}`} onClick={e => _selectCityAsync(e, x)}>{x}</li>)}
  </ul>
});

export default CityResults;
